import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":8,"column":17}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div id=\"talkTo-MLO\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"talkTo") || (depth0 != null ? lookupProperty(depth0,"talkTo") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"talkTo","hash":{},"data":data,"loc":{"start":{"line":4,"column":29},"end":{"line":4,"column":41}}}) : helper))) != null ? stack1 : "")
    + "</div>\n        <div id=\"talkYourMLO-MLO\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"talkYourMLO") || (depth0 != null ? lookupProperty(depth0,"talkYourMLO") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"talkYourMLO","hash":{},"data":data,"loc":{"start":{"line":5,"column":34},"end":{"line":5,"column":51}}}) : helper))) != null ? stack1 : "")
    + "</div>\n        <div id=\"yourMLO-MLO\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"yourMLO") || (depth0 != null ? lookupProperty(depth0,"yourMLO") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"yourMLO","hash":{},"data":data,"loc":{"start":{"line":6,"column":30},"end":{"line":6,"column":43}}}) : helper))) != null ? stack1 : "")
    + "</div>\n        <div id=\"fromYourLS-MLO\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"fromYourLS") || (depth0 != null ? lookupProperty(depth0,"fromYourLS") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fromYourLS","hash":{},"data":data,"loc":{"start":{"line":7,"column":33},"end":{"line":7,"column":49}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div style=\"display: none\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":9,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/mlo-override-module",
  "version": "1.0.1",
  "id": "mloOverrideModule",
  "containerID": "homeLoansMloOverrideModule",
  "moduleName": "home-loans-mlo-override-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "mlo-override-module",
  "data": {
    "init": "mloOverrideModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @class mloOverrideModule
 * @extends Module
 */
class mloOverrideModule extends Module {
  /**
   * @method constructor
   * @param {Object} options module params
   * @param {Object} context module params
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);
    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method init
   * @returns {void}
   */
  init() {
    this.Events.sub('HOME_LOANS_OVERVIEW_PHONE_NUMBER_RATES_REQUEST_SUCCESS', this.update);
    this.Events.sub('HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS', this.update);
    this.Events.sub('HOME_LOANS_LEARNING_MLO_INFO_REQUEST_SUCCESS', this.update);
    $('.contact-us #get-a-call-back-mlo').parent().parent().addClass('hide');
  }

  /**
   * @method update
   * @param {Object} response response object
   * @return {Boolean} false
   */
  update(response) {
    if (response.data.raw) {
      const data = response.data.raw;
      if (data.mloEnabled) {
        // begin engagement:
        $('.cta-hours').css('display', 'none');
        $('.contact-us-content').addClass('mlo-override');
        $('.contact-us-image').hide();
        $('.override-data').show();

        // Switching the modules non-mlo vs mlo

        $('.mlo-content').removeClass('hide');
        $('.non-mlo-content').addClass('hide');
        const talkTo = $('#talkTo-MLO').text();
        $('.talkTo').text(talkTo);
        $('.cta-contact #_dropdown').remove();
        $('.dropdown-image .spa-ui-layer-link#get_a_call_back_engagement').parent().parent().remove();
        // end engagement.

        // begin sticky <nav>
        const talkYourMLO = $('#talkYourMLO-MLO').text();
        $('.dropdown-control > a:first-child').text(talkYourMLO);
        $('.contact-us #get-a-call-back').closest('.flex-container-child').remove();
        // $('.contact-us #get-a-call-back-mlo').parent().parent().removeClass('hide');
        $('li.get_a_call_back_modal_open').addClass('hidden');
        $('.call-mlo').removeClass('hidden');
        // end sticky nav

        // rates-table-fallback-module
        $('.rates-table-fallback-module #get-a-call-back-button').remove();
        // end rates-table-fallback-module

        // begin Get a Call Back modal
        const $modal = $('#get_a_call_back_modal_layer');
        const fromYourLS = $('#fromYourLS-MLO').text();
        $modal.find('h5').text(fromYourLS);
        $('#get-a-call-back-mlo').parent().parent().parent().remove();
        // end Get a Call Back modal

        const $target = $('.mlo-override');
        $target.addClass('active');
        if (data.phoneExt) {
          $('.call-us').attr('data-ext', data.phoneExt);
          $('.call-mlo #callUsTabNav2').attr('data-ext', data.phoneExt);
          $('.call-mlo #callUsTabNav2').addClass('call-us');
        }
        if (data.firstName) {
          // first name
          $target.find('.firstName').text(data.firstName);

          // update mlo first name
          $target.find('.mlo-firstname').text(data.firstName);

          // hide
          $target.find('.mlo-firstname').parent().parent().parent().removeClass('hide');
        }
        if (data.lastName) {
          $target.find('.lastName').text(data.lastName);
        }
        if (data.phoneNumber) {
          const phone = data.phoneNumber;
          const formatted = `${phone.substr(0, 3)}.${phone.substr(3, 3)}.${phone.substr(6, 4)}`;
          // $target.find(".call-us").text(formatted)
          //    .attr("href", "tel:" + data.phoneNumber).hide();
          $('.inner-sticky-actual .sc-phone-number').hide();
          $('.call-mlo #callUsTabNav2').text(formatted).attr('href', `tel:${data.phoneNumber}`);
        }
        if (data.email) {
          $target.find('.email').text(data.email);
        }
        if (data.nmlSID) {
          $target.find('.nmlSID').text(data.nmlSID);
          $target.find('.mlo-data').attr('data-nmls', data.nmlSID);
        }

        // TODO Remove before May Release

        if (window.location.href.indexOf('?mock=mlo') > 0) {
          data.photoURL = 'https://mlo-uat.informationlogix.com/resource/photo/8429_201802071226.JPG';
          data.addressLine1 = '309 S Tollgate Rd';
        }
        if (data.photoURL) {
          $target.find('.photoURL').css({
            'background-image': `url(${data.photoURL})`
          });
        } else if (!data.photoURL) {
          $target.find('.photoURL').addClass('affiliate');
        } else {
          $('.photobox').remove();
        }
        if (data.city) {
          if (data.addressLine1) {
            $target.find('.address-line-one').text(data.addressLine1);
          }
          if (data.addressLine2) {
            $target.find('.address-line-two').html(`<br/>${data.addressLine2}`);
          }
          if (data.city) {
            $target.find('.city').text(`${data.city},`);
          }
          if (data.state) {
            $target.find('.state').text(data.state);
          }
        }
        if (data.bcZIP && data.bcZIP !== null && data.bcZIP !== '' && data.caiID && data.caiID !== null && data.caiID !== '') {
          const bbaURL = `${spaParams.siteParams.secureHost}${spaParams.siteParams.mloScheduleApptUrl}zip=${data.bcZIP}&caid=${data.caiID}`;
          $('a[href*="/mycommunications/public/appointments/getTopics.go?marketingCode="]').attr('href', bbaURL);
          $('#schedule-appt').attr('href', bbaURL);
          $('.tab-nav-schedule-meeting-link').attr('href', bbaURL);
        } else {
          // removing schedule appointment option from rates fall back
          $('.rates-table-fallback-module #schedule_an_appointment').remove();
          $('#schedule-appt').hide();
          // removing schedule appointment option from contact us module
          $target.find('#schedule-appt').closest('.flex-container-child').remove();
          $target.find('#get-a-call-back-mlo').closest('.flex-container-child').addClass('extra-right-padding');
          // mortgage and refinance tab
          // removing schedule appointment option from sticky bar, mobile only
          $('#small-tab-nav').find('#scheduleAnAppointmentMortgageTabNav').parent('li.online-banking').addClass('hide');
          // removing schedule appointment option from sticky bar
          $('#large-tab-nav').find('#scheduleAnAppointmentMortgageTabNav').parent('li.online-banking').addClass('hide');

          // refinance tab
          $('#small-tab-nav').find('#scheduleAnAppointmentRefinanceOverviewTabNav').parent('li.online-banking').addClass('hide');
          $('#large-tab-nav').find('#scheduleAnAppointmentRefinanceOverviewTabNav').parent('li.online-banking').addClass('hide');

          // home equity tab
          $('#small-tab-nav').find('#scheduleAnAppointmentHomeEquityOverviewTabNav').parent('li.online-banking').addClass('hide');
          $('#large-tab-nav').find('#scheduleAnAppointmentHomeEquityOverviewTabNav').parent('li.online-banking').addClass('hide');

          // mortgage product pages
          $('#small-tab-nav').find('#scheduleAnAppointmentTabNav').parent('li.online-banking').addClass('hide');
          $('#large-tab-nav').find('#scheduleAnAppointmentTabNav').parent('li.online-banking').addClass('hide');

          // closing cost calculator
          $('#small-tab-nav').find('#scheduleAnAppointmentClosingCostsTabNav').parent('li.online-banking').addClass('hide');
          $('#large-tab-nav').find('#scheduleAnAppointmentClosingCostsTabNav').parent('li.online-banking').addClass('hide');

          // removing schedule appointment option from engagement area
          $('#schedule_an_appointment_engagment').parents('li').addClass('hide');
        }
        if (data.prequalURL) ;
        return false;
      }
    }
  }
}
registerModuleClass({
  moduleClass: mloOverrideModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { mloOverrideModule as default, moduleConfig };
